// 仓库设置
import request from '@/utils/request'

export function getAllStore(params) {
    return request({
        url:'/storeSet/list',
        method:'get',
        params:params
    });
}

export function updateDefaultState(id) {
    return request({
        url:'/storeSet/setDefaultStore/'+id,
        method: 'put'
    });
}

export function saveOrUpdate(data) {
    return request({
        url:'/storeSet/saveOrUpdate',
        method: 'put',
        data:data
    });
}

export function delStore(id) {
    return request({
        url:'/storeSet/del/'+id,
        method:'delete'
    });
}
